import React, { Component } from "react";
import { Button } from "react-bootstrap";
import customForms from "../../../broadcasts/customForms";

/**
 * The body of a kind=custom item inside BroadcastModal (SPEC 10.3 / 7.4).
 *
 *   <CustomFormSlot item user settings onComplete onDefer onSkip />
 *
 * Looks the slot component up in broadcasts/customForms by item.custom_key and renders it with
 * { item, user, settings, payload: item.payload, onComplete, onDefer, onError, onTitle }:
 *
 *   onComplete  the slot saved through its own endpoint; the queue posts `completed` and advances
 *   onDefer     close for now without completing (COC step 1: the second step is due two days
 *               later); the queue advances and posts nothing
 *   onError     a message the slot wants shown above its body (role="alert"); "" clears it
 *   onTitle     the frame's (BroadcastModal) title setter, passed through unchanged: the NHO slot
 *               sends its translated title, the Happiness slot "Happiness Survey <year>"
 *
 * An unknown key (a build that does not know a key the server registered, or a null key)
 * renders a short "not available" body with one Done button that calls onSkip: the queue posts
 * `dismissed` best-effort and advances regardless, so a mandatory item can never trap the user.
 * The mismatch is logged with console.warn, not thrown: the server already skips unregistered
 * keys (SPEC 21.3), so this is a deploy-order warning, not a crash.
 */
class CustomFormSlot extends Component {
  state = { error: "" };

  componentDidMount() {
    if (!this.slotComponent()) {
      console.warn("[broadcasts] no custom form registered for key " + String(this.props.item.custom_key));
    }
  }

  slotComponent = () => {
    const key = this.props.item.custom_key;
    return key && customForms[key] ? customForms[key] : null;
  };

  onError = (message) => this.setState({ error: message || "" });

  render() {
    const Slot = this.slotComponent();
    if (!Slot) {
      return (
        <div className="broadcast-custom-unavailable">
          <p>This item is not available</p>
          <Button variant="primary" onClick={() => this.props.onSkip()}>Done</Button>
        </div>
      );
    }

    const { item, user, settings, onComplete, onDefer, onTitle } = this.props;
    return (
      <div className="broadcast-custom-body">
        {this.state.error ? (
          <div role="alert" className="alert alert-danger">{this.state.error}</div>
        ) : null}
        <Slot
          item={item}
          user={user}
          settings={settings}
          payload={item.payload}
          onComplete={onComplete}
          onDefer={onDefer}
          onError={this.onError}
          onTitle={onTitle}
        />
      </div>
    );
  }
}

export default CustomFormSlot;
